import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Response } from '../models/Response';
import { Template, TemplateField, TemplateUploadResponse } from '../models/Template';
import { Paginator } from '../models/Paginator';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  constructor(private http: HttpClient) { }

  /**
   * Obtener todas las plantillas paginadas
   */
  getTemplates(page: number = 1, filters?: any): Observable<Response<Paginator<Template>>> {
    let url = `${environment.API_URL}/template?page=${page}`;
    
    if (filters) {
      const params = new URLSearchParams(filters).toString();
      url += `&${params}`;
    }
    
    return this.http.get<Response<Paginator<Template>>>(url);
  }

  /**
   * Obtener una plantilla específica
   */
  getTemplate(id: number): Observable<Template> {
    return this.http.get<Template>(`${environment.API_URL}/template/fields/${id}`);
  }

  /**
   * Ver detalles de una plantilla (usando POST como requiere el backend)
   */
  viewTemplate(id: number): Observable<Template> {
    return this.http.get<Template>(`${environment.API_URL}/template/view/${id}`, {});
  }

  /**
   * Subir una nueva plantilla
   */
  uploadTemplate(formData: FormData): Observable<Response<TemplateUploadResponse>> {
    return this.http.post<Response<TemplateUploadResponse>>(
      `${environment.API_URL}/template/upload`, 
      formData
    );
  }

  /**
   * Actualizar información de una plantilla
   */
  updateTemplate(id: number, data: Partial<Template>): Observable<Response<Template>> {
    return this.http.put<Response<Template>>(`${environment.API_URL}/template/update/${id}`, data);
  }

  /**
   * Eliminar una plantilla
   */
  deleteTemplate(id: number): Observable<Response<any>> {
    return this.http.delete<Response<any>>(`${environment.API_URL}/template/${id}`);
  }

  /**
   * Extraer campos de una plantilla
   */
  extractFields(id: number, data?: any): Observable<Response<any>> {
    return this.http.post<Response<any>>(`${environment.API_URL}/template/fields/${id}`, data || {});
  }

  /**
   * Actualizar campos extraídos de una plantilla
   */
  updateTemplateFields(templateId: number, fields: TemplateField[]): Observable<Response<any>> {
    return this.http.put<Response<any>>(
      `${environment.API_URL}/template/${templateId}/fields`, 
      { fields }
    );
  }

  /**
   * Obtener plantillas por servicio
   */
  getTemplatesByService(serviceId: number): Observable<Response<Template[]>> {
    return this.http.get<Response<Template[]>>(`${environment.API_URL}/template/by-service/${serviceId}`);
  }

  /**
   * Previsualizar plantilla
   */
  previewTemplate(id: number): Observable<Blob> {
    return this.http.get(`${environment.API_URL}/template/${id}/preview`, {
      responseType: 'blob'
    });
  }

  /**
   * Descargar plantilla
   */
  downloadTemplate(id: number): Observable<Blob> {
    return this.http.get(`${environment.API_URL}/template/${id}/download`, {
      responseType: 'blob'
    });
  }
}
